import { render, staticRenderFns } from "./SankeyCard.vue?vue&type=template&id=52d80e80&scoped=true&"
import script from "./SankeyCard.vue?vue&type=script&lang=js&"
export * from "./SankeyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d80e80",
  null
  
)

export default component.exports